module.exports = "/images/vendor/flag-icon-css/flags/4x3/mg.svg?67f5922d788548be9d4900bebf2b5e63";